import { render, staticRenderFns } from "./accounting-open-invoices.vue?vue&type=template&id=0820f574&"
import script from "./accounting-open-invoices.vue?vue&type=script&lang=js&"
export * from "./accounting-open-invoices.vue?vue&type=script&lang=js&"
import style0 from "./accounting-open-invoices.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports